import styled from "styled-components"

export const ItemContainer = styled.div`
  height: 100px;
  width: 100%;
  padding: 5px;
  background-color: white;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
`
